import { render, staticRenderFns } from "./ModalAdicionarCpf.vue?vue&type=template&id=1cb581ed&"
import script from "./ModalAdicionarCpf.vue?vue&type=script&lang=js&"
export * from "./ModalAdicionarCpf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports